import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TimezoneService } from 'src/app/core/timezone.service';
import { LangService } from '../../core/lang.service';
import { ICandidateInfo } from 'src/app/ui-support/view-s-cand-credits/view-s-cand-credits.component';

export interface ICandLookup {
  contact_email: string;
  first_name: string;
  last_name: string;
  uid: string;
}

@Component({
  selector: 'user-lookup',
  templateUrl: './user-lookup.component.html',
  styleUrls: ['./user-lookup.component.scss']
})
export class UserLookupComponent implements OnInit {

  @Input() noNameSearch?: boolean = false;

  // public isLoaded: boolean = false;
  public contactEmail = new FormControl('');
  public firstName = new FormControl('');
  public lastName = new FormControl('');
  public candUID = new FormControl('');
  public isSearching: boolean;
  public isSearchCompleted: boolean;
  public isSearchFailed: boolean;
  public failReason: string;
  public isSending: boolean;
  public timezone : string;

  @Output() userInfo: ICandidateInfo[] = [];
  @Output() searchClicked = new EventEmitter<any>();
  @Output() isLoaded: boolean = false;

  constructor(
    private timezoneService: TimezoneService,
    private lang: LangService,
  ) { 
  }

  ngOnInit(): void {
    this.loadTimezone();
  }

  async loadReq() {
    this.resetData();
    this.isLoaded = false;
    this.isSearching = true;
    this.isSearchCompleted = false;
    this.isSearchFailed = false;
    try {
      // const creditInfo: ICreditHistory = await this.auth.apiGet(this.routes.SUPPORT_CAND_CREDITS, 1, {
      //   query: {
      //     contact_email: this.contactEmail.value,
      //     first_name: this.firstName.value,
      //     last_name: this.lastName.value,
      //     uid: this.candUID.value,
      //   }
      // });
      // this.userInfo = creditInfo.candidate_info;
      // this.creditRecords = creditInfo.credit_records; // need sanitization, status add labels
      // this.transactionRecords = creditInfo.transaction_history;
      this.isLoaded = true;
      this.isSearching = false;
      this.isSearchCompleted = true;
      this.isSearchFailed = false;
    } catch (error) {
      this.isLoaded = true;
      this.isSearching = false;
      this.isSearchCompleted = false;
      this.isSearchFailed = true;
      if (error.message == 'ERR_NO_CANDIDATE') {
        return this.failReason = 'No candidate found';
      }
      if (error.message == 'MISSING_PARAMS') {
        return this.failReason = 'Please enter search parameters';
      }
      alert('Error fetching candidate credits');
      console.error('Error fetching candidate credits', error);
    }
  }

  resetData () {
    this.userInfo = [];
    // this.creditRecords = [];
    // this.transactionRecords = [];
  }

  onSearchClick () {
    if (!this.validTTLookupVals()) return;
    const searchCriteria: ICandLookup = {
      contact_email: this.contactEmail.value,
      first_name: this.firstName.value,
      last_name: this.lastName.value,
      uid: this.candUID.value,
    }
    this.searchClicked.emit(searchCriteria);
    // loading props triggered, waiting for input.
    this.isSearching = true;
  }

  validTTLookupVals(){
    const properties = [
      this.firstName.value, 
      this.lastName.value, 
      this.candUID.value, 
      this.contactEmail.value, 
    ];
    return properties.some(item => item.trim() !== "")  // && !this.isLoading;
  }

  onResetClick(){
    this.firstName.reset();
    this.lastName.reset();
    this.candUID.reset();
    this.contactEmail.reset();
  }

  getDescriptionSlug() {
    return this.lang.tra('caec_user_lookup_descr', null, { timezone: this.timezone as string}) 
    // + ` ${this.timezone ? this.timezone : ''}.`; is it really necessary to add it here as well?
  }

  async getTimezone() {
    return this.timezoneService.getTimezone();
  }

  async loadTimezone() {
    try {
      this.timezone = await this.timezoneService.getTimezone(); // Wait for the timezone to resolve
    } catch (error) {
      console.error('Error fetching timezone:', error);
      // this.timezone = 'UTC'; // Fallback to a default timezone if an error occurs
    }
  }

}
